/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */

import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import React, { memo, useCallback, useEffect, useState } from "react";

import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
import {
  convertGBPtoPoundSymbol,
  convertKilometersToMiles,
} from "../../../../app/utils/commonFunction";
import { useIntl } from "react-intl";
import axios from "axios";

function DistanceCollectionReturn({
  isLoaded,
  setdistanceResponse,
  distanceResponse,
  orderDetail,
  keys,
  origin,
  destination,
  extraMilesData,
  type,
  postcode,
  state,
  handleCalculateExtraMiles,
  setAddressData,
  addressData,
}) {
  const intl = useIntl();
  const [map, setMap] = useState(null);
  const [routePath, setRoutePath] = useState([]);

  const containerStyle = {
    width: "400px",
    height: "400px",
  };
  const [mapCenter, setMapCenter] = useState({
    lat: 28.618698883918658,
    lng: 77.21201288871427,
  });

  const handleResponse = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.REACT_APP_SITE_URL}directions`,
        {
          params: { origin, destination },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.data?.success && response.data?.data) {
        const result = response.data.data.response;

        // Decode the overview polyline for map rendering
        if (
          result?.routes?.[0]?.overview_polyline?.points &&
          window.google?.maps?.geometry?.encoding
        ) {
          const decodedPath = window.google.maps.geometry.encoding.decodePath(
            result.routes[0].overview_polyline.points
          );
          setRoutePath(decodedPath);

          // Center map on the midpoint of the route
          const leg = result.routes[0].legs[0];
          if (leg?.start_location && leg?.end_location) {
            setMapCenter({
              lat:
                (leg.start_location.lat + leg.end_location.lat) / 2,
              lng:
                (leg.start_location.lng + leg.end_location.lng) / 2,
            });
          }
        } else {
          setRoutePath([]);
        }

        if (
          (keys === "collection" && addressData[keys] !== origin) ||
          (keys === "return" && addressData[keys] !== destination)
        ) {
          setAddressData((prev) => ({
            ...prev,
            [keys]: keys === "collection" ? origin : destination,
          }));
          setdistanceResponse((prev) => ({ ...prev, [keys]: result }));

          handleCalculateExtraMiles(result);
        }
      } else {
        setRoutePath([]);
      }
    } catch (error) {
      console.error("Error fetching directions:", error);
      setRoutePath([]);
    }
  };

  const onLoad = useCallback((marker) => setMap(marker), []);

  useEffect(() => {
    if (map && origin && destination && state?.extraMilesCall) {
      handleResponse();
    }
  }, [map, origin, destination, keys, state?.extraMilesCall]);

  return (
    <>
      <div className="mt-10">
        <div className="d-flex justify-content-between align-items-center pt-5 mb-4">
          <div className="text-center">
            <div>
              {keys === "collection"
                ? intl.formatMessage({ id: "Depot" })
                : "Collection"}
            </div>
            <div>
              <span className="symbol-label ml-2">
                <span
                  className="svg-icon svg-icon-sm svg-icon-primary"
                  id="kt_sendquote_panel_toggle"
                >
                  <SVG
                    title=" "
                    className="h-25 align-self-end"
                    src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")}
                  ></SVG>
                </span>
              </span>
            </div>
            <div>
              {type === "new_order" && keys === "collection"
                ? state?.depotData?.postcode
                : type === "new_order" && keys === "return"
                ? state?.collectionRetrun?.collection_postcode || postcode
                : orderDetail?.depot_details?.postcode}
            </div>
          </div>
          <div className="distance"></div>
          <div className="text-center">
            <div>
              {keys === "collection"
                ? intl.formatMessage({ id: "CUSTOMERS" })
                : "Return"}
            </div>
            <div>
              <span className="symbol-label ml-2">
                <span className="svg-icon svg-icon-sm svg-icon-primary">
                  <SVG
                    title=" "
                    className="h-25 align-self-end"
                    src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")}
                  ></SVG>
                </span>
              </span>
            </div>
            <div>
              {type === "new_order" ? (
                <>
                  {keys === "collection"
                    ? state?.collectionRetrun?.collection_postcode || postcode
                    : keys === "return"
                    ? state?.collectionRetrun?.return_postcode || postcode
                    : "-"}
                </>
              ) : (
                <>
                  {keys === "collection"
                    ? orderDetail?.collection_postcode
                    : orderDetail?.return_postcode || "-"}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="mt10 mb-10">
          {isLoaded && (
            <GoogleMap
              id="direction-example"
              mapContainerStyle={containerStyle}
              zoom={10}
              center={mapCenter}
              onLoad={onLoad}
            >
              {routePath.length > 0 && (
                <>
                  <Polyline
                    path={routePath}
                    options={{
                      strokeColor: "#4285F4",
                      strokeOpacity: 0.8,
                      strokeWeight: 5,
                    }}
                  />
                  <Marker position={routePath[0]} label="A" />
                  <Marker
                    position={routePath[routePath.length - 1]}
                    label="B"
                  />
                </>
              )}
            </GoogleMap>
          )}
        </div>

        <div className="row">
          <div className="col-md-6 mb-5">
            <strong>{intl.formatMessage({ id: "Distance" })}:</strong>{" "}
            {(distanceResponse &&
              distanceResponse[keys] &&
              distanceResponse[keys]?.routes.length > -1 &&
              distanceResponse[keys]?.routes[0]?.legs.length > -1 &&
              convertKilometersToMiles(
                distanceResponse[keys]?.routes[0]?.legs[0]?.distance.text
              )) ||
              "-"}{" "}
            {intl.formatMessage({ id: "Miles" })}
          </div>
          <div className="col-md-6 mb-5">
            <strong>{intl.formatMessage({ id: "Duration" })}:</strong>{" "}
            {(distanceResponse &&
              distanceResponse[keys] &&
              distanceResponse[keys]?.routes.length > -1 &&
              distanceResponse[keys]?.routes[0]?.legs.length > -1 &&
              distanceResponse[keys]?.routes[0]?.legs[0]?.duration.text) ||
              "-"}
          </div>
          <div className="col-md-6 mb-5">
            <strong>{intl.formatMessage({ id: "Extra.Miles" })}:</strong>{" "}
            {keys === "collection" && extraMilesData?.collectionMiles
              ? extraMilesData?.collectionMiles
              : keys === "return" && extraMilesData?.returnMiles
              ? extraMilesData?.returnMiles
              : "0"}{" "}
            {intl.formatMessage({ id: "Miles" })}
          </div>
          <div className="col-md-6 mb-5">
            <strong>
              {intl.formatMessage({ id: "Extra.Miles.Charges" })}:
            </strong>{" "}
            {keys === "collection" && extraMilesData?.collectionCurrency
              ? convertGBPtoPoundSymbol(extraMilesData?.collectionCurrency)
              : keys === "return" && extraMilesData?.returnCurrency
              ? convertGBPtoPoundSymbol(extraMilesData?.returnCurrency)
              : ""}{" "}
            {keys === "collection"
              ? extraMilesData?.collectionPrice
              : extraMilesData?.returnPrice}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(DistanceCollectionReturn);
